import { Capacitor } from '@capacitor/core'
import { LocalNotifications } from '@capacitor/local-notifications'
import { initializeApp } from 'firebase/app'
import { FirebaseMessaging } from '@capacitor-firebase/messaging'
import { FIREBASE_API } from '../config-global'
import axios from './axios'
import { Device } from '@capacitor/device'
import { random } from 'lodash'
import { getMessaging, onMessage } from 'firebase/messaging'

export class NotificationService {
  static firebaseApp = null
  static messaging = null

  static async pingNotification(payload) {
    try {
      await LocalNotifications.schedule({
        notifications: [
          {
            title: payload.title,
            body: payload.body,
            id: random(1, 100000),
          },
        ],
      })
    } catch (error) {
      console.error('Erro ao enviar notificação:', error)
    }
  }

  static async initialize() {
    if (!FIREBASE_API.projectId) {
      console.warn('Firebase: projectId not configured. Skipping notification initialization.')
      return
    }

    if (Capacitor.getPlatform() === 'web' && navigator.serviceWorker) {
      self.firebaseApp = initializeApp(FIREBASE_API)

      self.messaging = getMessaging(self.firebaseApp)
    }
  }

  static async onMessage(callback) {
    if (self.messaging) {
      onMessage(self.messaging, callback)
    }
  }

  static async setupNotifications() {
    const permissions = await this.requestPermissions()

    if (permissions?.receive !== 'granted') {
      console.warn('Permissão de notificação não concedida')
      return
    }

    const token = await this.getToken()
    if (!token) {
      throw new Error('Token de notificação não obtido')
    }

    const info = await this.getDeviceInfo()
    const { identifier } = await Device.getId()

    if (!info || !identifier) {
      throw new Error('Informações do dispositivo não obtidas')
    }

    await this.register({
      tokens: {
        firebase: token,
      },
      info,
      unique_device_id: identifier,
    })
  }

  static async getToken() {
    try {
      const options = { vapidKey: FIREBASE_API.vapidKey }

      if (Capacitor.getPlatform() === 'web') {
        options.serviceWorkerRegistration = await navigator.serviceWorker.register(
          '/firebase-messaging-sw.js'
        )
      }

      const { token } = await FirebaseMessaging.getToken(options)
      return token
    } catch (error) {
      console.error('Erro ao obter token:', error)
      return null
    }
  }

  static async register(payload) {
    await axios.post('oauth/user-devices', payload)
  }

  static async requestPermissions() {
    try {
      return await FirebaseMessaging.requestPermissions()
    } catch (error) {
      console.error('Erro ao solicitar permissão:', error)
    }
  }

  static async getDeviceInfo() {
    try {
      const { model, platform, operatingSystem, manufacturer, webViewVersion, isVirtual } =
        await Device.getInfo()

      return {
        model,
        platform,
        operating_system: operatingSystem,
        manufacturer: manufacturer ?? 'N/A',
        web_view_version: webViewVersion ?? 'N/A',
        is_virtual: isVirtual,
      }
    } catch (error) {
      console.error('Erro ao obter informações do dispositivo:', error)
    }
  }
}
